import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, JobProductInfo, ProductInfo, ProductWithPricingInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private readonly sdk = inject(ApiClient);

  getProducts(): Observable<ProductInfo[]> {
    return this.sdk.listProducts();
  }

  getProductsByJobId(jobId: string): Observable<JobProductInfo[]> {
    return this.sdk.getProductsByJobId(jobId);
  }

  getProductsForPostalCode(postalCode: string): Observable<ProductWithPricingInfo[]> {
    return this.sdk.listProductsForPostalCode(postalCode);
  }
}
